import * as React from 'react';
// @ts-ignore
import G2RLogo from '../../assets/g2rLogo.svg';
// @ts-ignore
import LmiLogo from '../../assets/LmiLogo.svg';
import styles from './Logo.scss';

export interface LogoProps {
    lmiLogo?: boolean;
}

const defaultProps: LogoProps = {
    lmiLogo: false,
};

export const Logo = ({ lmiLogo }: LogoProps) => {
    if (!!lmiLogo) {
        return (
            <>
                <img src={LmiLogo} className={styles.Logo} />
            </>
        );
    }
    return (
        <>
            <img src={G2RLogo} className={styles.Logo} />
        </>
    );

};
